import { Injectable } from '@angular/core'

import { PolicyService } from '@core/services/policy/policy.service'
import { AuthManagerService } from '@services/auth/auth-manager.service'

@Injectable({
  providedIn: 'root',
})
export class VariableincomePolicyService extends PolicyService {
  actionPolicies = {
    // palmyra-needle-angular-add-action-policy. Do not delete this line. Palmyra will add declaration here.
  }

  screenPolicies = {
    // palmyra-needle-angular-add-screen-policy. Do not delete this line. Palmyra will add declaration here.
  }

  fieldPolicies = {
    // palmyra-needle-angular-add-field-policy. Do not delete this line. Palmyra will add declaration here.
  }

  constructor(authService: AuthManagerService) {
    super(authService)
  }

  /**
   * is authorized to display this action
   * @param {string} useCase
   * @param {string} actionName
   * @return {Policy | boolean}
   */
  isActionRestricted(useCase, actionName): boolean {
    const policy =
      this.actionPolicies[useCase] && this.actionPolicies[useCase][actionName]
    return super.isActionRestricted(policy)
  }

  /**
   * is authorized to access to this screen
   * @param {string} useCase
   * @return {Policy | boolean}
   */
  isScreenAuthorized(useCase) {
    const policy = this.screenPolicies[useCase]
    return super.isScreenAuthorized(policy)
  }
  /**
   * is authorized to access to this field
   * @param {string} useCase
   * @param {string} fieldName
   * @return {Policy | boolean}
   */
  isFieldRestricted(useCase, fieldName) {
    const policy = this.fieldPolicies[useCase][fieldName]
    return super.isFieldRestricted(policy)
  }
}
